import * as React from 'react'

import { Box } from '~ui/components/layout/Box'
import { NoScrollbarBox } from '~ui/components/layout/NoScrollbarBox'

type TBoxProps = Omit<PropsOf<typeof Box>, 'position' | 'alignSelf'>

type TProps = RequiredChildren & TBoxProps

/**
 * Wrapper that makes it's content sticky inside of a grid column.
 * Optional `top` prop: to set sticky top position af the element.
 * Optional `height` prop: to set height of the box, serves to allow sticky element scrolling when content overflows it.
 */
export const StickyGridColumn: React.FC<TProps> = ({ children, ...boxProps }) => {
  return (
    <NoScrollbarBox
      top={0}
      height={`auto`}
      overflow={`auto`}
      padding={`none`}
      {...boxProps}
      position={`sticky`}
      alignSelf={`start`}
    >
      {children}
    </NoScrollbarBox>
  )
}
